var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',_vm._l((_vm.pubs),function(item){return _c('FullscreenItem',{key:item.id,attrs:{"item":item}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }